module.exports = new __parcel__URL__("machine_troops_button.2edb2abd.png").toString();